<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
    <button mat-icon-button class="close-button" (click)="onNoClick()">
        <mat-icon>close</mat-icon>
    </button>
    @if (pdfView) {
    <ng-container>
        <ngx-extended-pdf-viewer [src]="pdfView" [showSidebarButton]="true"
            [height]="'80vh'" [enablePrint]="true"></ngx-extended-pdf-viewer>


    </ng-container>
    }

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
    @if (isDownloadable){
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="downloadPdf()">Download</button>
    }
</mat-dialog-actions>